export const formatCurrency = (n, lng) => {
    if (n === undefined || Number.isNaN(n))
        return null;
    return new Intl.NumberFormat(lng, {
        style: 'currency',
        currency: 'CAD',
        currencyDisplay: 'narrowSymbol',
        notation: 'compact',
        maximumFractionDigits: 2,
    }).format(n);
};
